<template>
  <div class="set">
    <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div
      class="name"
      @click="gomeans"
    >
      <div class="tu">
        <img
          src="../../assets/user.png"
          alt=""
        >
      </div>
      <div class="centen">
        <div class="top">{{name}}</div>
        <div class="bottom">{{mobile}}</div>
      </div>
      <div class="jian">
      </div>
    </div> -->
    <!-- <div
      class="name list"
      @click="gorevise"
    >
      <div class="centen">
        申请额度
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
    <!-- <div
      class="name list"
      @click="gorevise"
    >
      <div class="centen">
        申请调额
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
     <div
      class="name list"
    >
      <div class="centen">
        授信额度：
      </div>
      <div class="jian qian">
       
        ￥{{m1}}
      </div>
    </div>
   <div
      class="name list"
    >
      <div class="centen">
        当前余额：
      </div>
      <div class="jian qian">
       
        ￥{{m2}}
      </div>
    </div>
    <div
      class="name list"
     
    >
      <div class="centen" style="text-align: center;">
        查询期间明细
      </div>
      <div class="jian">
        <!-- <van-icon name="arrow" /> -->
      </div>
    </div>
    <van-field @click="show" readonly v-model="value" label="选择时间" placeholder="请选择时间" />
     <van-field @click="show2" readonly v-model="value2" label="结束时间" placeholder="请选择结束时间" />
     <div class="but"  style="text-align: center;background-color: #fff;">
      <van-button @click="ca"   type="primary"  style="width: 40%;">查 询</van-button>
      <!-- <van-button style="width:50%" type="danger"  size="large" >查询全部</van-button> -->
     </div>
  
     
        <div class="list">
          <van-list
            
            :finished="finished"
       
            offset="500"
            @load="onLoad"
          >
             <van-cell v-for="item in list" :key="item.id"  >
                <div class="fa">
                <div class="">{{item.create_time_date}} </div>
                <div class="din">订单号：{{item.order_sa_id}} <span></span></div>
                <div class="din">说明：{{ item.remarks }} <span></span></div>
                <div class="money1">剩余额度：<span style="color: red;">￥{{item.fixed_credit_money}}</span> </div>
                </div>                
             </van-cell>  
          </van-list>

        </div>
    
<van-popup
        v-model="showPicker2"
        position="bottom"
      >
       <van-picker
  show-toolbar
  title="选择年月"
  :columns="columns"
  @confirm="ok"
  @cancel="close"
/>
      </van-popup>
      <van-popup
        v-model="showPicker"
        position="bottom"
      >
       <van-picker
  show-toolbar
  title="选择年月"
  :columns="columns"
  @confirm="ok2"
  @cancel="close"
/>
      </van-popup>
     <!-- <div
      class="name list"
      @click="fa(2)"
    >
      <div class="centen">
        利息查询
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
    <!-- <div
      class="name list"
      @click="ma"
    >
      <div class="centen">
        设置支付密码
      </div>
      <div class="jian">
        <van-icon name="arrow" />
      </div>
    </div> -->
    <!-- <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="mi">
        <p>请输入新密码</p>
        <input
          type="text"
          v-model="value"
        >
      </div>

      <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>

    </van-popup> -->
    <!-- <van-button
      class="but"
      type="danger"
      size="large"
      style="font-size:0.45rem;"
      @click="out"
    >退出登录</van-button> -->
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar, Toast, Button, Icon,Popup, List, Cell, Search, Dialog,  CountDown,Picker,Field } from 'vant';
Vue.use(NavBar).use(Toast).use(Button).use(Icon).use(Popup).use(List).use(Search).use(Dialog).use(CountDown).use(Picker).use(Popup)
.use(Field).use(Cell)
export default {
  created () {
    this.name = JSON.parse(localStorage.getItem('user-name')).id
    this.mobile = JSON.parse(localStorage.getItem('user-mobile')).id 
    this.axios.post('accountQuota', {}).then(res => {
       console.log(res)
       this.m2=res.data.data.shengyuedu
      
      }).catch(ref => { })
      this.axios.post('getjxyaccloglist',{ start:'' ,end:'',  }).then(res => {       
          console.log(res)       
          this.m1=res.data.begjxymoney
      
          // console.log(res)
      }).catch(ref => {
      })
  },
  data () {
    return {
      name: '',
      mobile: "",
     
      m1:'',
      m2: '',
      value: '',
      value2:'',
      title: '订单列表',
      nav: ['全部','返还', '使用'],
      active: 0,
      states: true,
      list: [],
      xlist: [],
      list1:[],
      list2:[],
      loading: false,
      finished: false,
      page: 1,
      columns: [
        // 第一列
        {
          values: [ '2025','2026','2027','2028'],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: ['1', '2', '3','4','5','6','7','8','9','10','11','12'],
          defaultIndex: 0,
        },
      ],
      showPicker2:false,
      showPicker:false,
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    gomeans () {
      // this.$router.push('means')
    },
    goaddres () {
      this.$router.push('address')
    },
    gorevise () {
      this.$router.push('bai')
    },
    fa (id) {
      this.$router.push({name:'bai2',query:{id}})
    },
    ma(){
this.show=true
    },
    // ok(){
    //   this.axios.post('setPayPwd', { pwd: this.value, }).then(res => {
    //    console.log(res)
    //    this.show=false
    //     Toast(res.data.msg)
    //   }).catch(ref => { })
    // },
    out () {
      localStorage.setItem('user-level', JSON.stringify({ id: 0 }))
      localStorage.setItem('user-name', JSON.stringify({ id: '' }))
      localStorage.setItem('vip', JSON.stringify({ id: 0 }))
      localStorage.setItem('user', JSON.stringify({ id: 0 }))
      localStorage.setItem('user-mobile', JSON.stringify({ id: "" }))
      localStorage.setItem('token', JSON.stringify({ id: "" }))
      this.$router.push('login')
    },
    show(){
    this.showPicker2=true
  },
   show2(){
    this.showPicker=true
  },
  ok(v,i){
    console.log(v,i)
    this.value=v[0]+'-'+v[1]
    this.showPicker2=false
  },
   ok2(v,i){
    console.log(v,i)
    this.value2=v[0]+'-'+v[1]
    this.showPicker=false
  },
  close(){
    this.showPicker2=false
    this.showPicker=false
  },
  ca(){
    console.log()
    if( this.value){

    }else{
      Toast('请选择开始时间')
      return
    }
    if( this.value2){

    }else{
      Toast('请选择结束时间')
      return
    }
    this.active=0
    // console.log( this.value+'-1')s
    let ed1 = this.value+'-1'
    let st1 = this.value2+'-30'
    this.axios.post('getjxyaccloglist',{ start:(new Date(ed1).getTime())/1000  ,end:(new Date(st1).getTime())/1000,  }).then(res => {       
          console.log(res)       
       
        this.list=res.data.data
      this.list.forEach(v => {
        v.ca=Number(v.fixed_credit_money_old)-Number(v.fixed_credit_money)
})
          this.finished=true
          // console.log(res)
      }).catch(ref => {
      })
  },
  onLoad (v) {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // this.deng(v)
    },
  },
}
</script>  
<style lang="less" scoped>
.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.set {
  height: 100%;
  background-color: #f5f5f5;
}
.name {
  display: flex;
  height: 2.08rem;
  background-color: #fff;
  padding: 0.2rem;
  border-bottom: 1px solid #eee;
  .tu {
    flex: 0.3;
    img {
      width: 1.52rem;
    }
  }
  .centen {
    flex: 1;
    padding-top: 0.2rem;
    .top {
      font-size: 0.4rem;
      color: #333;
    }
    .bottom {
      padding-top: 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
  }
  .jian {
    flex: 0.13;
    padding-top: 0.6rem;
    font-size: 0.5rem;
    color: #e3e3e3;
  }
  
}
.list {
  // padding-left: 0.5rem; 
  height: 1.3rem;
  .centen {
    font-size: 0.38rem;
  }
  .jian {
    flex: 0.1;
    padding-top: 0.2rem;
  }
  .qian{
    flex: 0.5;
text-align: right;
    color: #000;
    font-size: 0.4rem;
  }
}
// .but {
//   position: fixed;
//   bottom: 0;
// }
</style>